var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarShape = function SvgStarShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "star-shape_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.355 3.908a.715.715 0 0 1 1.298 0l2.105 4.534c.104.225.317.38.563.41l4.962.6c.605.074.847.82.402 1.235l-3.662 3.404a.72.72 0 0 0-.215.661l.962 4.906a.716.716 0 0 1-1.05.763l-4.368-2.43a.72.72 0 0 0-.696 0l-4.368 2.43a.716.716 0 0 1-1.05-.763l.961-4.906a.72.72 0 0 0-.215-.661l-3.661-3.404a.716.716 0 0 1 .401-1.234l4.962-.602a.72.72 0 0 0 .563-.409z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star-shape_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 3h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 3h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 3h3v3h-3zM3 6h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 6h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 6h3v3h-3zM3 9h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 9h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 9h3v3h-3zM3 12h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 12h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 12h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 12h3v3h-3zM3 15h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 15h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 15h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 15h3v3h-3zM3 18h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 18h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 18h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 18h3v3h-3z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#ddd",
    strokeWidth: 0.25,
    d: "M11.345 3.823a.723.723 0 0 1 1.31 0l2.127 4.58c.106.226.32.382.569.413l5.012.607c.61.074.856.828.406 1.247l-3.699 3.438a.72.72 0 0 0-.217.668l.971 4.956a.723.723 0 0 1-1.06.77l-4.413-2.455a.72.72 0 0 0-.702 0l-4.413 2.455a.723.723 0 0 1-1.06-.77l.97-4.955a.72.72 0 0 0-.216-.669L3.232 10.67a.723.723 0 0 1 .405-1.247l5.012-.607a.72.72 0 0 0 .569-.414z",
    style: {
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }));
};
export default SvgStarShape;